import React, { Component } from 'react'
import { graphql, StaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import Swiper from 'react-id-swiper'
import Sticker from 'react-stickyfill'
import { Waypoint } from 'react-waypoint'

import communitiesStyles from './communities.module.scss'

import MapSVG from './map-components/map'
import Minimap from './map-components/minimap'

import styles from './communities.module.scss'

export class communities extends Component {
  state = {
    points: ['p10'],
    slidesOrder: [],
  }

  swiperParams = {
    loop: false,
    speed: 600,
    freeMode: false,
    grabCursor: false,
    noSwiping: false,
    centeredSlides: true,
    slidesPerView: 1.2,
    spaceBetween: 20,
    breakpoints: {
      992: {
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 0,
      },
    },
  }

  clickPoint = e => {
    const point = e.currentTarget.id
    this.setState({
      points: [point],
    })

    const slideNum = parseInt(e.currentTarget.dataset.slide)
    if (slideNum !== undefined) {
      this.state.swiper.slideTo(slideNum)
    }
  }

  render() {
    return (
      <>
        <section
          id="map"
          className={`container-fluid mapSection ${communitiesStyles.mapSection} `}
        >
          <Sticker>
            <StaticQuery
              query={query}
              render={data => {
                const quotes = data.allStrapiMapQuotes.edges

                return (
                  <>
                    <div className={styles.mapContent}>
                      <div className={styles.swiperContainer}>
                        <Swiper
                          {...this.swiperParams}
                          getSwiper={swiper => {
                            this.setState({ swiper })
                            if (window.innerWidth > 991) {
                              swiper.slideTo(2)
                            }
                          }}
                        >
                          <div className={styles.card}>
                            <img
                              alt=""
                              className={styles.mapMobile}
                              src={`./cardMinimaps/map-mobile.png`}
                            />
                          </div>
                          {quotes.map(quoteNode => {
                            const quote = quoteNode.node

                            return (
                              <div key={quote.id} className={styles.card}>
                                <Img
                                  fluid={quote.photo.childImageSharp.fluid}
                                />
                                <div className={styles.cardContent}>
                                  <div className={styles.cardMinimap}>
                                    <img
                                      alt=""
                                      className={styles.imageMinimap}
                                      src={`./cardMinimaps/cm-${quote.point}-100.png`}
                                    />
                                  </div>
                                  <svg
                                    version="1.1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    x="0px"
                                    y="0px"
                                    width="100px"
                                    height="79px"
                                    viewBox="0 0 100 79"
                                    className={styles.quoteMark}
                                  >
                                    <g>
                                      <path
                                        fill="#ffffff"
                                        d="M46.1,12.6l-14,23.5h14v45.8H0V34L27.7,0L46.1,12.6z M103.5,12.6l-14,23.5h14v45.8h-46V34L85.1,0L103.5,12.6z"
                                      />
                                    </g>
                                  </svg>
                                  <div className={styles.cardTexts}>
                                    <p className={styles.cardText}>
                                      {quote.text}
                                    </p>
                                    <p className={styles.cardLead}>
                                      {quote.lead}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            )
                          })}
                        </Swiper>
                      </div>
                      <div className={styles.mapContainer}>
                        <h2 className={styles.mapCTA}>
                          O mapa da violência
                          <br />
                          <span className={styles.smaller}>
                            Clique no mapa para conhecer a história dos
                            moradores que vivem sob ameaça
                          </span>
                        </h2>
                        <MapSVG
                          clickPoint={this.clickPoint}
                          points={this.state.points}
                          className={`${styles.svg}`}
                        />
                        <Minimap className={styles.minimap} />
                      </div>
                    </div>
                  </>
                )
              }}
            />
          </Sticker>
          <Waypoint
            onEnter={() => {
              this.props.changeHeaderVisibility(false)
            }}
            onLeave={() => {
              this.props.changeHeaderVisibility(true)
            }}
          />
        </section>
      </>
    )
  }
}

export default communities

const query = graphql`
  query mapQuotesQuery {
    allStrapiMapQuotes(sort: { fields: point, order: DESC }) {
      edges {
        node {
          id
          lead
          text
          point
          photo {
            childImageSharp {
              fluid(maxWidth: 1920, quality: 90) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  }
`
